"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = require("react-dom");
require("intersection-observer");
var HotSpot = /** @class */ (function () {
    function HotSpot(component, params, timeDelay) {
        var _this = this;
        // public name: string = ''
        this.params = {};
        this.hasExplosure = false; // 是否已经曝光
        this.element = null;
        this.timer = null;
        this.observer = new IntersectionObserver(function (entries) {
            _this.startVisible(entries[0]);
        }, {
            threshold: [0.5, 1]
        });
        this.params = params;
        this.timeDelay = timeDelay;
        var componentDidMount = component.componentDidMount;
        var componentWillMount = component.componentWillMount;
        // 监听
        component.componentDidMount = function () {
            if (componentDidMount) {
                componentDidMount.bind(component)();
            }
            try {
                _this.element = react_dom_1.findDOMNode(component);
                _this.subscribeEvent();
            }
            catch (error) {
                throw new Error('component is invalid');
            }
        };
        // 取消监听
        component.componentWillMount = function () {
            _this.unsubscribeEvent();
            if (componentWillMount) {
                componentWillMount.bind(component)();
            }
        };
    }
    HotSpot.prototype.getParams = function () {
        return {
            params: this.params
        };
    };
    HotSpot.prototype.subscribeEvent = function () {
        if (this.element) {
            this.observer.observe(this.element);
        }
    };
    HotSpot.prototype.unsubscribeEvent = function () {
        if (this.element) {
            this.observer.unobserve(this.element);
        }
    };
    HotSpot.prototype.startVisible = function (entrie) {
        var _this = this;
        if (!this.element) {
            return;
        }
        if (this.timer) {
            clearTimeout(this.timer);
        }
        // console.log(this.timeDelay)
        this.timer = setTimeout(function () {
            if (entrie.isIntersecting && entrie.intersectionRatio > 0.5) {
                _this.hasExplosure = true;
                _this.unsubscribeEvent();
            }
        }, this.timeDelay ? this.timeDelay : 2000);
    };
    return HotSpot;
}());
exports.default = HotSpot;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/operation-report/dist/components/HotSpot/HotSpot.js
// module id = 381
// module chunks = 0